module.exports = __webpack_public_path__ + "img/gb.d721b202.jpg";